import { AfterViewInit, Directive, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { IEntity } from 'viggo-sistemas-core-web';

import { Observable } from 'rxjs';

import { Utils } from '@app/shared/helpers/utils';
import { IParceiro } from '../../model';
import { ParceiroService } from '../../services/parceiro.service';
import { AddresFormComponent } from '../form-address/form-address';
import { ContactFormComponent } from '../form-contact/form-contact.component';

/**
 * Esta classe implementa um controller para os multi passos do stepper
 *
 * Por ser uma classe generica, é nescessário que a classe que a herde
 * forneça os providers
 */

@Directive()
export class ParceiroEditBaseComponent<T extends IEntity>
  implements AfterViewInit {
  // referencia ao component de form para endereços
  @ViewChild(AddresFormComponent)
  protected _addresFormComponent: AddresFormComponent;
  // referencia ao component de form para contatos
  @ViewChild(ContactFormComponent)
  protected _contactFormComponent: ContactFormComponent;

  // form de informações pessoais
  protected _informacoesPessoaisFormComponent;
  // utilizado para pegar o a entidade do router
  protected actRouter: ActivatedRoute;
  // utilizado pra fazer interações com o backend
  protected parceiroService: ParceiroService;
  // utilizado para mostrar mensagens de sucesso
  protected snackBar: MatSnackBar;
  // utilizado para navegar entre as telas
  protected router: Router;

  entity: T;
  // verifica se a view já iniciou
  viewInit: boolean;
  // titulo do formulário
  formHeader: string;
  // rota para navegar entre as paginas
  protected routeUrl: string;
  // nome a ser mostrado nos snak bars
  protected parceiroName: string;
  /**
   *
   * @param routeUrl rota definida no routes
   * @param parceiroName nome da entidade, a ser mostrado no snackBar
   */
  constructor(routeUrl: string, parceiroName = 'parceiro') {
    this.viewInit = false;
    this.routeUrl = routeUrl;
    this.parceiroName = parceiroName;
    this.formHeader = `Adicionar ${this.parceiroName}`;
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewInit = true;
    }, 1);
  }
  ngOnInit(): void {
    this.entity = this.actRouter.snapshot.data.entity;

    if (this.entity.id) {
      this.formHeader = `Editar ${this.parceiroName}`;
    }
  }
  get formAddres(): UntypedFormGroup {
    return this.viewInit ? this._addresFormComponent.form : ({} as UntypedFormGroup);
  }

  get formInformacoesPessoais(): UntypedFormGroup {
    return this.viewInit && this._informacoesPessoaisFormComponent
      ? this._informacoesPessoaisFormComponent.form
      : ({} as UntypedFormGroup);
  }
  get formValid(): boolean {
    var valid = this.viewInit && this.formAddres.valid && this.formInformacoesPessoais.valid
    const blocked_actions = localStorage.getItem('INTEGRACAO') === 'true' ? true : false
    if(blocked_actions) valid = true
    return valid;
  }

  /**
   * Chama o service para editar um parceiro
   * @param parceiro parceiro a ter informações editadas
   */
  updateParceiro(parceiro: IParceiro): Observable<IParceiro> {
    return this.parceiroService.update(parceiro);
  }
  /**
   * retorna para o parceiro list
   */
  returnRouter(): void {
    this.router.navigate([this.routeUrl]);
  }
  /**
   * Chama o service para salvar um parceiro
   * @param parceiro parceiro a ser salvo
   */
  saveParceiro(parceiro: IParceiro): Observable<IParceiro> {
    parceiro = Utils.trimAttributes(parceiro);
    return this.parceiroService.insert(parceiro);
  }
  onCancel(): void {
    if (this.formAddres.dirty || this.formInformacoesPessoais.dirty) {
      // eslint-disable-next-line no-alert
      const r = window.confirm('Todas as informações serão perdidas');
      if (r) {
        this.returnRouter();
      }
    } else this.returnRouter();
  }
}
